import React from 'react';
import { CheckIcon } from 'lucide-react';
const NUMBERS = [{
  value: '6',
  label: 'Complete Modules'
}, {
  value: '5',
  label: 'Strategic Bonuses'
}, {
  value: 'PRO',
  label: 'Coaching Level'
}, {
  value: 'FULL',
  label: 'Court Coverage'
}];
const COVERAGE = ['Technical Progressions', 'Professional Drills', 'Session Planning', 'Ready-To-Coach Sessions', 'Tactical Development', 'Decision-Making', 'Player Assessment', 'Individual, Pair & Group Training'];
export function SystemOverview() {
  return <section aria-labelledby="system-title" className="w-full bg-white px-4 py-8 sm:px-6" data-id="element-211" data-mp="pxpylwr87u1n">
      <div className="mx-auto max-w-5xl text-center" data-id="element-212" data-mp="13x7l25h1uv7u">
        <span className="font-head text-[11px] font-semibold uppercase tracking-wider text-brand sm:text-xs" data-id="element-213" data-mp="yx31u7orbmdx">
          The complete system to stop improvising your sessions
        </span>
        <h2 id="system-title" className="mt-1 font-display text-3xl uppercase leading-none text-charcoal sm:text-5xl" data-id="element-214" data-mp="2fd5z6nr347fx">
          Padel Coach Pro™
        </h2>
        <p className="mx-auto mt-2 max-w-2xl text-[13px] leading-snug text-softgray sm:text-[15px]" data-id="element-215" data-mp="238gqx2fszenk">
          Advanced progressions, professional drills, session planning, court-ready training,
          tactical development, and player assessment tools. Everything organized and ready when you
          need it.
        </p>

        <dl className="mt-4 grid grid-cols-2 gap-2 lg:grid-cols-4" data-id="element-216" data-mp="1kg4rangjarh4">
          {NUMBERS.map(item => <div key={item.label} className="rounded-xl border border-charcoal/10 bg-ivory px-2 py-3 text-center" data-id="element-217" data-mp="1peg2b1ikf80x">
              <dd className="font-display text-2xl uppercase leading-none text-brand sm:text-3xl" data-id="element-218" data-mp="1ucr913dkd2ex">
                {item.value}
              </dd>
              <dt className="mt-1 font-head text-[10px] font-semibold uppercase tracking-wide text-softgray sm:text-xs" data-id="element-219" data-mp="11pwuso7caz9w">
                {item.label}
              </dt>
            </div>)}
        </dl>

        <p className="mt-6 font-head text-sm font-semibold uppercase tracking-wide text-charcoal sm:text-base" data-id="element-220" data-mp="yn0j5ebsrdhg">
          Complete coverage for professional padel coaching
        </p>
        <ul className="mt-2 grid grid-cols-2 gap-2 text-left lg:grid-cols-4" data-id="element-221" data-mp="18e4v0566ei82">
          {COVERAGE.map(item => <li key={item} className="flex items-center gap-2 rounded-lg border border-brand/25 bg-brand/5 px-3 py-2 text-xs font-medium leading-snug text-charcoal sm:text-[13px]" data-id="element-222" data-mp="13fjtm2f6tsi1">
              <CheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-223" data-mp="are9nhvyk7j9" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}